const ReferenceCodes = {
  Userpoolseatsnotavailable: 'c5c9a0f3b4f9ffe6a70fa0011edc990b'
}

export default {
  ReferenceCodes
}

export const INVALID_PARAM_EXCEPTION = 'InvalidParameterException'
export const INVALID_PARAM_EXCEPTION_MSG = 'Invalid User name or password. Please check your user name and password.'
export const NOT_AUTHOR_EXCEPTION = 'NotAuthorizedException'
export const NOT_AUTHOR_EXCEPTION_MSG = 'User name or password is incorrect. Please note that user names and passwords are case-sensitive and try again.'
export const USER_NOT_FOUND_EXCEPTION = 'UserNotFoundException'
export const USER_NOT_FOUND_EXCEPTION_MSG = '' // using NOT_AUTHOR_EXCEPTION_MSG
export const USER_NOT_FOUND_CHPASS_EXCEPTION_MSG = 'Request failed. Note that user names and passwords are case-senstitive. Please try again.'
export const PASS_RESET_REQ_EXCEPTION = 'PasswordResetRequiredException'
export const PASS_RESET_REQ_EXCEPTION_MSG = 'Password reset required for the user. Please use Forgot Password link.'
export const CODE_MISMATCH_EXCEPTION = 'CodeMismatchException'
export const CODE_MISMATCH_EXCEPTION_MSG = 'Verification code is invalid. Please check the most recent email and try again.'
export const EXPIRED_CODE_EXCEPTION = 'ExpiredCodeException'
export const EXPIRED_CODE_EXCEPTION_MSG = 'Verification code is expired. Please request a new code and try again.'




// WEBPACK FOOTER //
// ./src/constants/index.js